import type { FC, ReactNode } from 'react'

import { ButtonLink } from '@/components/generals/button'
import { MediaImage } from '@/components/generals/media-image'

export const FragranceFeature: FC = (): ReactNode => {
    return (
        <section id='fragrance' aria-labelledby='fragrance-title' className='bg-foreground text-background'>
            <div className='mx-auto grid max-w-[1600px] items-center gap-12 px-6 py-20 sm:px-10 lg:grid-cols-12 lg:gap-0 lg:px-16 lg:py-32'>
                <div className='reveal lg:col-span-5 lg:pr-12'>
                    <p className='eyebrow text-background/60'>
                        Les Parfums
                    </p>

                    <h2 id='fragrance-title' className='mt-5 font-heading text-4xl font-light leading-[1.05] sm:text-5xl lg:text-6xl'>
                        Composed in Grasse, worn in Paris
                    </h2>

                    <p className='mt-6 text-[15px] leading-relaxed text-background/70'>
                        Our perfumer works from the fields above Grasse, where jasmine, tuberose and rose are still picked at dawn. Every Vaurel fragrance is built on rare naturals, left to mature for weeks before bottling and poured into heavy glass designed to be refilled rather than replaced.
                    </p>

                    <ButtonLink href='/collections/fragrance' variant='outline-light' className='mt-10'>
                        Discover the fragrances
                    </ButtonLink>
                </div>

                <div className='relative aspect-square overflow-hidden lg:col-span-6 lg:col-start-7'>
                    <MediaImage
                        src='/images/home/fragrance.jpg'
                        alt='A turquoise glass perfume bottle with a sculpted gold cap in raking sunlight'
                        sizes='(min-width: 1024px) 45vw, 100vw'
                        className='object-cover'
                    />
                </div>
            </div>
        </section>
    )
}
